<template>
    <i @click="$emit('click')" class="iconfont iconfont-out" :class="classStr" :style="styleStr"></i>
</template>

<script>
export default {
    name: 'Icon',
    props: {
        //图标颜色，有效的颜色值
        color: { type: String, default: "" },
        //大小，font-size值
        size: { type: String, default: "" },
        //icon class 同于iconfont
        name: { type: String, default: "icontishi-qianggou" },
        //自定义样式类
        customClass: { type: String, default: "default" }
    },
    computed:{
        styleStr: function(){
            return [
                this.color ? `color: ${this.color}` : '',
                this.size ? `font-size: ${this.size}` : ''
            ].join(';')
        },
        classStr: function(){
            return [
                this.name,
                this.customClass
            ].join(' ')
        }
    },
    methods:{
        click (e) {
            this.$emit('click' , e)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
    .iconfont{
        font-size: 0.14rem
    }
</style>



// WEBPACK FOOTER //
// src/components/Icon.vue